// src/utils/date.js
// Вынесено из ExperimentCard.js (step5) — общий форматтер даты для
// ExperimentCard и ExperimentRow.
export const formatDate = (dateString) => {
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};
